import { TurnClock } from './TurnClock.js'

export interface TurnSlotProps {
  /** The room's deadline, whoever it belongs to. */
  readonly endsAt: number | null
  /** Whether this phone's own turn is being counted. */
  readonly mine: boolean
}

/**
 * The countdown's place, kept whether or not there is a countdown in it.
 *
 * The clock used to be mounted only on your own turn, so it appeared and
 * vanished — and everything below it moved by its height. On a phone that is
 * the keyboard, the card grid, the number pad: the controls a child is aiming
 * at, jumping 53px at the exact moment the turn changes hands, which is the
 * moment she is about to press something. Measured on a Pixel 5: the first
 * control sat at y=212 on her turn and y=159 otherwise.
 *
 * **Hidden rather than unmounted**, so the space is the clock's own and not a
 * number somebody guessed. `TurnClock` returns null when there is no deadline,
 * so a reserved height would have had to be a constant kept in step with a
 * component in another file — which is the kind of pair that comes apart. This
 * cannot: whatever the clock measures, that is what is held.
 *
 * `aria-hidden` with it, because a countdown that is not yours is not
 * something to read out. It goes on ticking behind the scenes, which costs one
 * timer and buys a layout that does not move.
 */
export function TurnSlot({ endsAt, mine }: TurnSlotProps) {
  return (
    <div
      className={`flex justify-center ${mine ? '' : 'invisible'}`}
      aria-hidden={mine ? undefined : true}
    >
      <TurnClock endsAt={endsAt} />
    </div>
  )
}
